import React, { useEffect, useState } from "react";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableFooter,
  TablePagination,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Modal,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";

import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

const MainBodyModal = ({
  openModal,
  handleCloseModal,
  responseAPI,
  selectedFormat,
}) => {
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [selectedValue, setSelectedValue] = useState(""); // Select value
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [formData, setFormData] = useState({
    channel_id: null,
    files_id: [],
  });
  const [responseListChannels, setResponseListChannels] = useState();
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [borderColorMet, setBorderColorMet] = useState("gray");
  const [labelText, setLabelText] = useState("met_uid");
  const [isEditMetUid, setIsEditMetUid] = useState(false);
  const [sortByEpisode, setSortByEpisode] = useState(true);

  useEffect(() => {
    setInputValue(responseAPI.met_uid);
    getDataListChannels();
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
      });
    } else {
      setFormData({ channel_id: null, files_id: [] });
    }
    // // Добавляем поле episode в каждую серию
    // // Группируем файлы по сезону
    // const groupedBySeason = responseAPI.files.reduce((acc, file) => {
    //   const season = file.season;
    //   if (!acc[season]) acc[season] = []; // Если сезона нет в группе, создаем
    //   acc[season].push(file); // Добавляем файл в соответствующую группу
    //   return acc;
    // }, {});

    // // Преобразуем обратно в плоский массив с нумерацией эпизодов
    // responseAPI.files = Object.values(groupedBySeason) // Получаем массив групп
    //   .flatMap((seasonFiles) =>
    //     seasonFiles.map((file, index) => ({
    //       ...file,
    //       episodes: index + 1, // Нумеруем серии в пределах сезона
    //     }))
    //   );
  }, []);

  useEffect(() => {
    if (responseAPI) {
      setInputValue(responseAPI.met_uid);
      const uniqueSeasons = [
        ...new Set(responseAPI.files.map((file) => file.season)),
      ];
      setSeasons(uniqueSeasons);
    }
    setSelectedValue("");
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (!responseAPI.serial) {
      setFormData({
        channel_id: null,
        files_id: [responseAPI.files[0].file_id],
      });
    } else {
      setFormData({ channel_id: null, files_id: [] });
    }
    // // Добавляем поле episode в каждую серию

    // // Группируем файлы по сезону
    // const groupedBySeason = responseAPI.files.reduce((acc, file) => {
    //   const season = file.season;
    //   if (!acc[season]) acc[season] = []; // Если сезона нет в группе, создаем
    //   acc[season].push(file); // Добавляем файл в соответствующую группу
    //   return acc;
    // }, {});

    // // Преобразуем обратно в плоский массив с нумерацией эпизодов
    // responseAPI.files = Object.values(groupedBySeason) // Получаем массив групп
    //   .flatMap((seasonFiles) =>
    //     seasonFiles.map((file, index) => ({
    //       ...file,
    //       episodes: index + 1, // Нумеруем серии в пределах сезона
    //     }))
    //   );
  }, [responseAPI]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (responseAPI) {
      setInputValue(responseAPI.met_uid);
    }
  }, [selectedFormat, selectedChannelName]);

  useEffect(() => {
    if (responseAPI.serial) {
      setFormData((prevFormData) => ({
        ...prevFormData, // Сохраняем остальные поля объекта formData
        files_id: selectedCheckboxes, // Обновляем только поле files_id
      }));
    }
  }, [selectedCheckboxes]);

  useEffect(() => {
    if (isEditMetUid && inputValue === responseAPI.met_uid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(
        inputValue === "" ||
          labelText === "изменено" ||
          inputValue === responseAPI.met_uid
      );
    }
  }, [inputValue]);

  useEffect(() => {
    setSelectedCheckboxes([]);
    setSelectedSeasons([]);
    setCheckboxValues([]);
    selectSeason([]);
    if (responseAPI.met_uid) {
      setBorderColorMet("blue");
    } else {
      setBorderColorMet("gray");
    }
  }, [responseAPI.title]);

  async function getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    setFormData((prevFormData) => ({
      ...prevFormData, // Сохраняем остальные поля объекта formData
      channel_id: event.target.value, // Обновляем только поле files_id
    }));
  };

  const handleCheckboxChange = (id, season) => {
    setSelectedCheckboxes((prev) => {
      // Определяем, нужно ли добавить или убрать чекбокс
      const isRemoving = prev.includes(id);
      const updatedCheckboxes = isRemoving
        ? prev.filter((item) => item !== id)
        : [...prev, id];

      // Обновляем сезоны
      setSelectedSeasons((prevSeasons) => {
        if (!isRemoving) {
          // Если чекбокс добавляется, добавить сезон, если его еще нет
          return prevSeasons.includes(season)
            ? prevSeasons
            : [...prevSeasons, season];
        } else {
          // Если чекбокс убирается, проверить, остались ли чекбоксы для этого сезона
          const hasOtherCheckboxesForSeason = updatedCheckboxes.some(
            (checkboxId) => {
              // Проверяем, связан ли оставшийся чекбокс с этим сезоном
              const checkboxSeason = getSeasonByCheckboxId(checkboxId); // Функция для получения сезона по id
              return checkboxSeason === season;
            }
          );

          return hasOtherCheckboxesForSeason
            ? prevSeasons
            : prevSeasons.filter((s) => s !== season);
        }
      });

      return updatedCheckboxes; // Возвращаем обновленный список чекбоксов
    });
  };

  const getSeasonByCheckboxId = (checkboxId) => {
    if (!Array.isArray(responseAPI.files)) {
      console.error("responseAPI.files не является массивом");
      return null;
    }

    const film = responseAPI.files.find((file) => file.file_id === checkboxId);
    return film ? film.season : null;
  };

  const handleClickSendData = () => {
    if (
      formData.channel_id !== null &&
      Array.isArray(formData.files_id) &&
      formData.files_id.length > 0
    )
      // ------- новый код
      if (sortByEpisode) {

        // Создаем Map для быстрого доступа к данным о файлах
        const episodeMap = new Map(
          responseAPI.files.map((item) => [
            item.file_id,
            { season: item.season, episode: item.episode },
          ])
        );

        // Сортировка по сезону и эпизоду
        formData.files_id.sort((a, b) => {
          const dataA = episodeMap.get(a);
          const dataB = episodeMap.get(b);

          // Сначала сортировка по сезону, затем по эпизоду
          if (dataA.season === dataB.season) {
            return dataA.episode - dataB.episode;
          }
          return dataA.season - dataB.season;
        });
      }
    // console.log("formData.files_id " + formData.files_id);

    Api.post(`${BASE_API_URL}/api/timeline/add`, formData)
      .then((response) => {
        console.log("transfer ok");
        setFormData({ channel_id: null, files_id: [] });
        setSelectedCheckboxes([]);
        setSelectedSeasons([]);
        selectSeason([]);
        setCheckboxValues([]);
        setInputValue("");
        setSelectedValue("");
      })
      .catch((error) => {
        console.log("transfer bad");
      });
  };

  //------ новый код

  //--- для нового поля

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setLabelText("met_uid");
    setBorderColorMet("red");
  };

  async function setMetUid(id) {
    Api.post(`${BASE_API_URL}/api/movie/met/${id}`, {
      met_uid: inputValue,
    });
  }
  const handleSend = async () => {
    try {
      await setMetUid(responseAPI.id);
      setLabelText("изменено");
      setBorderColorMet("blue");
      setIsDisabled(true);
      setIsEditMetUid(true);
    } catch {
      alert("transfer met_uid bad");
    }
  };
  const selectSeason = (seasonNumber) => {
    if (responseAPI) {
      // Фильтруем серии по номеру сезона
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === seasonNumber)
        .map((file) => file.file_id);

      // Добавляем выбранные серии сезона к selectedCheckboxes
      setSelectedCheckboxes((prevSelected) => {
        // Добавляем только уникальные file_id, если они ещё не выбраны
        const updatedSelection = [
          ...new Set([...prevSelected, ...seasonFiles]),
        ];
        return updatedSelection;
      });
    }
  };
  const handleCheckboxChangeSeason = (event, season) => {
    const { checked } = event.target;
    setSelectedSeasons(
      (prevSelected) =>
        checked
          ? [...prevSelected, season] // Добавляем сезон при выборе
          : prevSelected.filter((s) => s !== season) // Удаляем сезон при снятии отметки
    );

    if (checked) {
      // Если чекбокс выбран, добавляем все серии сезона
      selectSeason(season);
    } else {
      // Если чекбокс снят, удаляем все серии сезона из выбранных
      const seasonFiles = responseAPI.files
        .filter((file) => file.season === season)
        .map((file) => file.file_id);

      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((fileId) => !seasonFiles.includes(fileId))
      );
    }
  };
  const handleCheckboxChangeSortByEpisode = () => {
        setSortByEpisode(
          (v) => !v
        );
  }

  return (
    <Modal
      open={openModal}
      onClose={() => {
        setSelectedCheckboxes([]);
        setSelectedSeasons([]);
        selectSeason([]);
        handleCloseModal();
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          maxWidth: 450,
          minWidth: 450,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Paper
          sx={{
            backgroundColor: "#E0F7FA",
            padding: 1,
            borderRadius: 2,
            marginBottom: 2,
          }}
        >
          <Typography variant="h6" align="center" color="primary">
            {responseAPI.title} - {selectedFormat}
          </Typography>
        </Paper>
        <Paper
          sx={{
            backgroundColor: "#E0F7FA",
            padding: 1,
            borderRadius: 2,
            width: 440,
            maxWidth: 440,
            minWidth: 440,
            overflowX: "auto",
          }}
        >
          {responseAPI && responseListChannels && (
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <TableCell>
                      <Select
                        value={selectedValue}
                        onChange={handleSelectChange}
                        displayEmpty
                        fullWidth
                      >
                        <MenuItem value="">
                          <em>Выберите канал</em>
                        </MenuItem>
                        {responseListChannels.map((element, index) => (
                          <MenuItem key={index} value={element.id}>
                            {element.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                  </TableRow>
                  {responseAPI.serial && (
                    <TableRow>
                      <TableCell
                        colSpan={seasons.length} // Объединяем ячейки в строке
                        sx={{
                          maxWidth: "440px", // Ограничиваем максимальную ширину
                          overflow: "hidden", // Скрываем переполнение
                          textOverflow: "ellipsis", // Добавляем многоточие для переполнения
                          whiteSpace: "nowrap", // Не переносим текст на новую строку
                          display: "flex",
                        }}
                      >
                        <Box display="flex" flexWrap="wrap" maxWidth="390px">
                          {seasons.map((season) => (
                            <FormControlLabel
                              key={season}
                              control={
                                <Checkbox
                                  checked={selectedSeasons.includes(season)}
                                  onChange={(event) =>
                                    handleCheckboxChangeSeason(event, season)
                                  }
                                />
                              }
                              label={`Сезон ${season}`}
                              sx={{ flexShrink: 0 }} // Предотвращаем сжатие элементов
                            />
                          ))}
                          <FormControlLabel
                            key={sortByEpisode}
                            control={
                              <Checkbox
                                checked={sortByEpisode}
                                onChange={ handleCheckboxChangeSortByEpisode}
                              />
                            }
                            label={"Сортировка по порядку"}
                            sx={{ flexShrink: 0 }} // Предотвращаем сжатие элементов
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell
                      colSpan={seasons.length + 1}
                      sx={{ maxWidth: 390 }}
                    >
                      {responseAPI.serial && (
                        <Box
                          sx={{
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "8px",
                            marginBottom: "16px",
                            width: "95%",
                            minHeight: "50px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              fontSize: "12px",
                              marginBottom: "4px",
                              textAlign: "center",
                              color: "gray",
                            }}
                          >
                            Выбранные серии
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "14px",
                              lineHeight: "1.4",
                              textAlign: "center",
                            }}
                          >
                            {selectedSeasons
                              .map((season) => {
                                // Фильтруем серии для текущего сезона
                                const selectedFiles = responseAPI.files
                                  .filter(
                                    (file) =>
                                      file.season === season &&
                                      selectedCheckboxes.includes(file.file_id) // Проверяем только выбранные file_id
                                  )
                                  .map((file) => file.episode); // Получаем эпизоды для группировки

                                if (selectedFiles.length === 0) return null; // Если серий нет, пропускаем

                                // Группируем серии
                                const groupedSeries = [];
                                let rangeStart = null;

                                for (let i = 0; i < selectedFiles.length; i++) {
                                  if (rangeStart === null) {
                                    rangeStart = selectedFiles[i]; // Начало нового диапазона
                                  }

                                  // Если текущий элемент не продолжает диапазон
                                  if (
                                    selectedFiles[i + 1] !==
                                      selectedFiles[i] + 1 ||
                                    i === selectedFiles.length - 1
                                  ) {
                                    if (rangeStart === selectedFiles[i]) {
                                      // Добавляем одиночную серию
                                      groupedSeries.push(`${rangeStart}`);
                                    } else {
                                      // Добавляем диапазон
                                      groupedSeries.push(
                                        `${rangeStart}-${selectedFiles[i]}`
                                      );
                                    }
                                    rangeStart = null; // Сбрасываем диапазон
                                  }
                                }

                                return `Сезон ${season}, серии ${groupedSeries.join(
                                  ", "
                                )}`;
                              })
                              .filter(Boolean) // Убираем пустые строки (если нет выбранных серий для сезона)
                              .join("; ")}
                          </Typography>
                        </Box>
                      )}

                      {responseAPI.serial ? (
                        /* Если это сериал */
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${seasons.length}, 1fr)`,
                            maxHeight: "400px",
                            maxWidth: 400,
                            minWidth: 400,
                            width: 400,
                            overflowY: "auto",
                            overflowX: "auto",
                          }}
                        >
                          {seasons.map((season) => {
                            const seasonFiles = responseAPI.files.filter(
                              (file) => file.season === season
                            );

                            return (
                              <Box
                                key={season}
                                sx={{
                                  border: "1px solid #ddd",
                                  padding: "2px",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  align="center"
                                  sx={{
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Сезон {season}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  {seasonFiles.map((file, index) => (
                                    <FormControlLabel
                                      key={file.file_id}
                                      control={
                                        <Checkbox
                                          checked={selectedCheckboxes.includes(
                                            file.file_id
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              file.file_id,
                                              file.season
                                            )
                                          }
                                          sx={{ padding: "1px" }} // Уменьшаем отступ внутри чекбокса
                                        />
                                      }
                                      label={
                                        <Box
                                          component="span"
                                          sx={{
                                            fontSize: "11px", // Уменьшаем шрифт
                                            lineHeight: "1.2", // Уменьшаем межстрочный интервал
                                          }}
                                        >
                                          серия {file.episode}
                                        </Box>
                                      }
                                      sx={{
                                        margin: 0, // Убираем внешние отступы для элемента
                                      }}
                                    />
                                  ))}
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      ) : (
                        /* Если это не сериал */
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            padding: "8px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            rowGap: "4px", // Уменьшаем расстояние между строками
                          }}
                        >
                          {responseAPI.files.map((file) => (
                            <FormControlLabel
                              key={file.file_id}
                              control={
                                <Checkbox
                                  checked={true}
                                  sx={{ padding: "4px" }} // Уменьшаем отступ внутри чекбокса
                                />
                              }
                              label={
                                <Box
                                  component="span"
                                  sx={{
                                    fontSize: "inherit",
                                  }}
                                >
                                  {file.name}
                                </Box>
                              }
                              sx={{
                                margin: 0, // Убираем внешние отступы
                              }}
                            />
                          ))}
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Paper>
        <Box sx={{ mt: 2 }}>
          <TextField
            label={labelText}
            variant="outlined"
            value={inputValue}
            onChange={handleInputChange}
            fullWidth
            autoComplete="off"
            inputProps={{ form: "off" }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: borderColorMet, // Задаем цвет рамки
                },
                "&:hover fieldset": {
                  borderColor: borderColorMet,
                },
                "&.Mui-focused fieldset": {
                  borderColor: borderColorMet,
                },
              },
            }}
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSend}
              disabled={isDisabled}
            >
              изменить met_uid
            </Button>
          </Box>
        </Box>
        <Box sx={{ textAlign: "center", marginTop: 2 }}>
          <Button
            onClick={handleClickSendData}
            variant="contained"
            color="primary"
            disabled={
              !(
                formData.channel_id !== null &&
                Array.isArray(formData.files_id) &&
                formData.files_id.length > 0
              ) // Кнопка будет неактивной, если условие не выполняется
            }
          >
            Отправить
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MainBodyModal;
